import React, { useState } from 'react';
import { useBrand } from '../../../app/config/brand';
import { FormData, getCourtsByState } from '../../../shared/data/formData';
import { Button } from '../../../shared/components/ui/Button';
import { Input } from '../../../shared/components/ui/Input';
import { Select } from '../../../shared/components/ui/Select';
import { Card } from '../../../shared/components/ui/Card';
import { PageTitle } from '../../../shared/components/ui/PageTitle';
import { SectionTitle } from '../../../shared/components/ui/SectionTitle';

const CustomerMatters: React.FC = () => {
  const brand = useBrand();
  const [selectedState, setSelectedState] = useState('');

  const courtOptions = selectedState
    ? [{ value: '', label: 'All courts' }, ...getCourtsByState(selectedState).slice(1)]
    : [{ value: '', label: 'All courts' }];

  return (
    <div>
      <PageTitle>Matters</PageTitle>
      <Card className="mb-6">
        <SectionTitle>Search</SectionTitle>
        <p className="text-sm mb-4" style={{ color: brand.colors.textLight }}>
          The matters page is filtered to the last 3 months of matters - to see additional matters you can modify the search filter
        </p>
        <div className="grid grid-cols-12 gap-4 mb-4">
          <Input label="Matter / Billing Code:" className="col-span-2" />
          <Input label="Date Created From:" defaultValue="10/23/2025" className="col-span-2" />
          <Input label="Date Created To:" defaultValue="1/23/2026" className="col-span-2" />
          <Select label="Created By:" options={[{value: '', label: 'All users'}, {value: 'me', label: 'Me'}]} className="col-span-2" />
          <Select label="Status:" options={FormData.matterStatuses} className="col-span-2" />
        </div>
        <div className="grid grid-cols-12 gap-4 items-end">
          <Select
            label="State:"
            options={[{ value: '', label: 'All states' }, ...FormData.states.slice(1)]}
            className="col-span-2"
            onChange={(e) => setSelectedState(e.target.value)}
          />
          <Select label="Court:" options={courtOptions} className="col-span-2" />
          <Input label="Case Information:" placeholder="Case number / case title" className="col-span-3" />
          <div className="col-span-2"><Button className="w-full">SEARCH</Button></div>
        </div>
      </Card>

      <Card padding={false}>
        <table className="w-full text-sm">
          <thead style={{ backgroundColor: brand.colors.bgLight }}>
            <tr className="border-b" style={{ borderColor: brand.colors.border }}>
              {['Matter / Billing Code', 'Created', 'Created By', 'Case Number', 'Case Name', 'Court', 'Last Order Date', 'Status', 'Actions'].map(h => (
                <th key={h} className="text-left px-4 py-3 font-medium" style={{ color: brand.colors.secondary }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr><td colSpan={9} className="text-center py-8" style={{ color: brand.colors.textLight }}>No matters found</td></tr>
          </tbody>
        </table>
        <div className="flex items-center justify-between px-4 py-3 border-t" style={{ borderColor: brand.colors.border }}>
          <div className="flex items-center gap-1 text-sm">
            {[
              { glyph: '\u23EE', label: 'First page' },
              { glyph: '\u25C0', label: 'Previous page' },
              { glyph: '\u25B6', label: 'Next page' },
              { glyph: '\u23ED', label: 'Last page' },
            ].map(({ glyph, label }) => (
              <button key={label} aria-label={label} className="p-1.5 rounded-sm hover:bg-gray-100">{glyph}</button>
            ))}
          </div>
          <div className="flex items-center gap-2 text-sm" style={{ color: brand.colors.textLight }}>
            <select
              id="customer-matters-page-size"
              className="border rounded-sm px-2 py-1"
              style={{ borderColor: brand.colors.border }}
            >
              {FormData.itemsPerPage.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
            </select>
            <label htmlFor="customer-matters-page-size">Items per page</label>
            <span className="ml-2">1 - 0 of 0 items</span>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CustomerMatters;
